module.exports = __webpack_public_path__ + "static/media/camera-home.6b8da4c2.svg";